export const OPEN_ADD_FORM_MODAL = 'OPEN_ADD_FORM_MODAL';
export const CLOSE_ADD_FORM_MODAL = 'CLOSE_ADD_FORM_MODAL';

function openAddFormModal(imyTier, addImyLayer) {
  return {
    type: OPEN_ADD_FORM_MODAL,
    imyTier,
    addImyLayer,
    isAddFormModalShown: true,
    results: null
  };
}

function closeAddFormModal() {
  return {
    type: CLOSE_ADD_FORM_MODAL,
    imyTier: null,
    addImyLayer: false,
    isAddFormModalShown: false,
    isAddingForm: false,
    addingFormResults: null
  };
}

export function showAddFormModal(imyTier, addImyLayer) {
  return (dispatch) => {
    dispatch(openAddFormModal(imyTier, addImyLayer));
  };
}

export function hideAddFormModal() {
  return (dispatch) => {
    dispatch(closeAddFormModal());
  };
}
